module.exports = __webpack_public_path__ + "deb43f8d.png";